<template>
  <div class="edit-video-box">
    <el-dialog
      class="game-dialog"
      :title="'AI伴侣流水'"
      :visible.sync="dialogVisible"
      width="1000px"
      :before-close="handleClose"
      :close-on-click-modal="false">
      第三方用户ID: {{ aiMateUid }}<br/><br/>
      <!--表格数据-->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        ref="multipleTable"
        height="520">
        <el-table-column prop="orderId" label="订单Id" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.orderId }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="credit_delta" label="此次操作积分数" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.credit_delta }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="post_credit" label="操作后剩余积分数" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.post_credit }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation_type" label="操作类型" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.operation_type }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at" label="操作时间" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.created_at | changeDate }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/api";
export default {
  data() {
    return {
      uid: "",
      aiMateUid: "",
      dialogVisible: false,
      loading: false,
      tableData: [],
      total: 0,
    };
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
      this.tableData = [],
      this.aiMateUid = "",
      this.uid = "",
      this.total = 0
    },
    // 提交修改
    getList() {
      this.loading = true;
      API.getUserAiMateTransList({uid: this.uid}).then((res) => {
        if (res.code === 200 && res.data.list) {
          this.tableData = res.data.list || [];
          this.total = res.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
      });
    },
    // 打开弹窗、传递需要编辑的参数
    open(row) {
      this.uid = row.uid;
      this.aiMateUid = row.aiMateUid;
      this.getList();
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss">
.edit-video-box {
  .el-input {
    width: 150px;
  }
}
.form_item {
  display: flex;
}
.game-dialog {
  .el-dialog__body {
    padding: 25px 25px 0 !important;
  }
}
.el-form-item__content {
  margin-left: 0px !important;
}
</style>
